import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import {useStyles} from "../ArticleWarehouses.style";
import clsx from "clsx";
import ArticleWarehouseRowProperties from "./ArticleWarehouseRowProperties";
import ShowDate from "../../../shared_components/Info/ShowDate/ShowDate";
import ShowSellerBasicInfo from "../../../shared_components/Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
import ExpandoMenu from "../../../ui_components/ExpandoMenu/ExpandoMenu";
import ArticleWarehouseStockButton from '../../../shared_components/Buttons/ArticleWarehouseStockButton/ArticleWarehouseStockButton';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import NewArticleWarehouseButton from '../../../shared_components/Buttons/NewArticleWarehouseButton/NewArticleWarehouseButton';
import ViewTransactionsButton from '../../../shared_components/Buttons/ViewTransactionsButton/ViewTransactionsButton';

const ArticleWarehouseRowMedium: React.FC<ArticleWarehouseRowProperties> = ({
                                                            articleWarehouse,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {


    const classes = useStyles();
    const i18n = useI18nContext();

    return (
        <div
            className={clsx(classes.article_warehouse_info_container)}>
            <ShowSellerBasicInfo autofill name={articleWarehouse.name}/>
            <ShowDate label={i18n.translate("CREATED")} timestamp={articleWarehouse.createdAt}/>
            <ExpandoMenu>
                <NewArticleWarehouseButton
                    size={ButtonSize.SMALL}
                    onSave={onUpdate}
                    articleWarehouseId={articleWarehouse.id}
                    showText
                    type={ButtonType.SECONDARY}
                />
                <ArticleWarehouseStockButton articleWarehouse={articleWarehouse} onClose={onUpdate}/>
                <ViewTransactionsButton
                    type={ButtonType.SECONDARY}
                    size={ButtonSize.SMALL}
                    onSave={onUpdate}
                    showText
                    entityId={articleWarehouse.id}
                    showMoneyTransactions={false}
                />
            </ExpandoMenu>
        </div>
    )
}

export default ArticleWarehouseRowMedium;
